import { createSliceHookFactories } from '@tdp/common/form';

import { botSlice } from './slice';
import { botEventSubscriptionSlice } from './slice.eventSubscription';

export const {
  createZoomHook: createBotZoomHook,
  createEditsHook: createBotEditsHook,
  createStringInputPropsHook: createBotInputPropsHook,
  createRevertHook: createBotRevertHook,
} = createSliceHookFactories(botSlice);

export const {
  createZoomHook: createBotEventSubscriptionZoomHook,
  createEditsHook: createBotEventSubscriptionEditsHook,
  createStringInputPropsHook: createBotEventSubscriptionInputPropsHook,
  createRevertHook: createBotEventSubscriptionRevertHook,
} = createSliceHookFactories(botEventSubscriptionSlice);
